import * as React from 'react';

// components
import Route from 'modules/router';
import FetchEvent from '../modules/fetch-event';
import EventGrant from '../modules/event-grant-ownership';
import PlatformSelectionScreen from '../screens/platform-selection';
import LoginScreen from '../screens/login';
import ErrorScreen from '../screens/error';
import SuccessScreen from '../screens/success';
import EndOperationScreen from '../screens/end-operation';

// types
import { IAction } from 'types/action';

// constants
import { OPERATION_ENDING_STATUS } from 'modules/end-operation/end-operation.constants';
import {
    STEP_PLATFORM_SELECTION,
    STEP_LOGIN,
    STEP_ERROR,
    STEP_SUCCESS,
    STEP_END_OF_OPERATION,
    STEP_FETCH_EVENT,
    STEP_GRANT_OWNERSHIP
} from './router.constants';
import { SET_LOGIN_SESSION, LOG_OUT_DONE } from 'modules/login/login.constants';
import {
    EVENT_SET_DATA,
    EVENT_SET_ERROR,
    EVENT_SET_OWNERSHIP_DATA,
    EVENT_SET_OWNERSHIP_ERROR
} from 'modules/event-manager/event-manager.constants';
import { SET_PLATFORM } from '../modules/platform-selection/platform-selection.constants';
import { ownershipErrorAction } from 'modules/event-manager/event-manager.actions';
import { ERROR_TYPES } from 'modules/event-manager/event-manager-error';

const commonTransitions = {
    [LOG_OUT_DONE]: { STEP_PLATFORM_SELECTION },
    ['ON_ERROR']: { STEP_ERROR } // TODO replace with real error action
};

export const Router: React.FunctionComponent = () => {
    return (
        <>
            <Route
                is={STEP_FETCH_EVENT}
                transitions={{
                    ...commonTransitions,
                    [EVENT_SET_DATA]: { STEP_END_OF_OPERATION },
                    [EVENT_SET_ERROR]: { STEP_ERROR }
                }}
                render={<FetchEvent />}
            />
            <Route
                is={STEP_END_OF_OPERATION}
                transitions={{
                    ...commonTransitions,
                    [OPERATION_ENDING_STATUS]: {
                        [STEP_PLATFORM_SELECTION]: (action: IAction) => action.payload.isValid
                    }
                }}
                render={<EndOperationScreen />}
            />
            <Route
                is={STEP_PLATFORM_SELECTION}
                transitions={{ ...commonTransitions, [SET_PLATFORM]: { STEP_LOGIN } }}
                render={<PlatformSelectionScreen />}
            />
            <Route
                is={STEP_LOGIN}
                transitions={{
                    ...commonTransitions,
                    [SET_LOGIN_SESSION]: { STEP_GRANT_OWNERSHIP }
                }}
                render={<LoginScreen />}
            />
            <Route
                is={STEP_GRANT_OWNERSHIP}
                transitions={{
                    ...commonTransitions,
                    [EVENT_SET_OWNERSHIP_DATA]: { STEP_SUCCESS },
                    [EVENT_SET_OWNERSHIP_ERROR]: {
                        [STEP_ERROR]: (action: ownershipErrorAction) => action.payload.type !== ERROR_TYPES.ALREADY_OPTED ,
                        [STEP_SUCCESS]: (action: ownershipErrorAction) => action.payload.type === ERROR_TYPES.ALREADY_OPTED
                    }
                }}
                render={<EventGrant />}
            />
            <Route is={STEP_ERROR} transitions={{ ...commonTransitions }} render={<ErrorScreen />} />
            <Route is={STEP_SUCCESS} transitions={{ ...commonTransitions }} render={<SuccessScreen />} />
        </>
    );
};

Router.displayName = 'Router';

export default Router;
